import React from 'react';
import 'components/ListAccounts/List.scss';
import Label from 'components/form/Label/Label';
import SectionContainer from 'components/Containers/SectionContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import classnames from 'classnames';
import { useEventHandler } from 'hook/event.hook';
import { useHistory } from 'react-router-dom';
import {
  CLICK,
  VIEW_MODULE,
} from 'externals/_tracking/types/eventTypes.constants';

import {
  BALANCE_TRANSFER,
  CASH_BACK,
  REWARDS,
  TRAVEL,
  SECURED,
} from 'types/cardsOffersFilters.constants';

const MoreButtonsForCC = [
  {
    name: BALANCE_TRANSFER,
    link: 'BALANCE_TRANSFER',
  },
  {
    name: CASH_BACK,
    link: 'CASH_BACK',
  },
  {
    name: REWARDS,
    link: 'REWARDS',
  },
  {
    name: TRAVEL,
    link: 'TRAVEL',
  },
  {
    name: SECURED,
    link: 'SECURED',
  },
];

function MoreWaysToBrowseCard() {
  const eventHandler = useEventHandler();
  const history = useHistory();

  React.useEffect(() => {
    eventHandler(VIEW_MODULE, {
      componentName: 'More Ways Footer',
    });
    //eslint-disable-next-line
  }, []);

  const goToFilteredCC = (name, url) => {
    eventHandler(CLICK, {
      'Click Type': 'More Ways Footer',
      'Button Label': name,
    });
    history.push(`/offers/creditcard?creditCardType=${url}`);
  };

  return (
    <SectionContainer>
      <Label
        type="H3"
        typeHeader={'h3'}
        className={'text-24 bold margLR40 margB24'}
      >
        More ways to browse cards
      </Label>
      <FlexContainer className={'margLR40 gap-14 m-flex-wrap'}>
        {MoreButtonsForCC.map(({ name, link }) => {
          return (
            <Button
              mrphType="standardBlue"
              className="Body1"
              rounded="100px"
              neverFullWidth
              onClick={() => {
                goToFilteredCC(name, link);
              }}
            >
              <FlexContainer
                justifyCenter
                className={classnames('marglr16 m-marglr0 text-14 width100px')}
              >
                {name}
              </FlexContainer>
            </Button>
          );
        })}
      </FlexContainer>
    </SectionContainer>
  );
}

export default MoreWaysToBrowseCard;
